module.exports = __webpack_public_path__ + "img/移动通信.4cda4477.png";